import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import Symbol from "./Symbol";

const SymbolNode = Node.create({
  name: "symbol",

  group: "inline",

  content: "text*",

  inline: true,

  selectable: true,

  addKeyboardShortcuts() {
    return {
      Backspace: () => {
        const node = this.editor.view.state.doc.nodeAt(
          this.editor.view.state.selection.$from.pos - 1,
        );

        if (!node) {
          return false;
        }

        if (node.text?.length === 1) {
          this.editor.chain().focus().deleteNode("symbol").run();

          return true;
        }

        return false;
      },
    };
  },

  onTransaction() {
    if (
      this.editor.view.state.selection.$from.pos === 1 &&
      this.editor.view.state.doc.nodeAt(1)?.type.name === "symbol"
    ) {
      this.editor.commands.setTextSelection({
        from: 2,
        to: this.editor.view.state.selection.$to.pos,
      });
    }
  },

  onUpdate() {
    const node = this.editor.view.state.doc.nodeAt(
      this.editor.view.state.selection.$from.pos - 1,
    );

    if (!node) {
      return;
    }

    if (node.type.name === "symbol" && node.content.childCount === 0) {
      this.editor.commands.deleteRange({
        from: this.editor.view.state.selection.$from.pos - 1,
        to: this.editor.view.state.selection.$from.pos - 1 + node.nodeSize,
      });
    }
  },

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  addAttributes() {
    return {
      color: {
        default: "green",
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "symbol-node",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["symbol-node", mergeAttributes(HTMLAttributes), 0];
  },

  addNodeView() {
    return ReactNodeViewRenderer(Symbol);
  },
});

export default SymbolNode;
